/**
 * Compact £ display for Fleet Cost Assumptions tables and tooltips.
 */

export function formatFleetMoneyK(value: number): string {
  if (value >= 1_000_000) return `£${(value / 1_000_000).toFixed(1)}m`;
  if (value >= 1000) return `£${(value / 1000).toFixed(1)}k`;
  return `£${Math.round(value)}`;
}

/** Numeric value behind formatFleetMoneyK so tooltip lines add up visually. */
export function displayFleetMoneyAmount(value: number): number {
  if (value >= 1_000_000) return Math.round(value / 100_000) / 10 * 1_000_000;
  if (value >= 1000) return Math.round(value / 100) / 10 * 1000;
  return Math.round(value);
}
